module.exports = __webpack_public_path__ + "static/media/ad-tissot.b2bbf966.png";